import { http } from "../http";

export interface SendAdminNotificationPayload {
  notificationType: "EMAIL" | "PUSH" | "BOTH";
  recipientType:
    | "USER"
    | "CLINICIAN"
    | "ALL_USERS"
    | "ALL_CLINICIANS"
    | "SPECIFIC_IDS";
  recipientIds?: number[];
  title: string;
  message: string;
  titleAr?: string;
  messageAr?: string;
  emailSubject?: string;
  emailTemplate?: string;
  data?: Record<string, any>;
}

export interface SendCustomEmailPayload {
  recipients: string[];
  subject: string;
  message: string;
  template?: string;
  data?: Record<string, any>;
}

export interface NotificationResponse {
  success: boolean;
  message: string;
  results: {
    emailsSent?: number;
    pushNotificationsSent?: number;
    failed?: number;
    sent?: number;
  };
  recipientCount?: number;
}

/**
 * Send notification from admin panel (push, email, or both)
 */
export const sendAdminNotification = async (
  payload: SendAdminNotificationPayload
): Promise<NotificationResponse> => {
  const response = await http.post("/notifications/admin/send", payload);
  return response.data;
};

/**
 * Send custom email from admin panel
 */
export const sendCustomEmail = async (
  payload: SendCustomEmailPayload
): Promise<NotificationResponse> => {
  const response = await http.post("/notifications/admin/send-email", payload);
  return response.data;
};

/**
 * Get user notifications
 */
export const getUserNotifications = async (
  userId: number,
  limit = 50,
  offset = 0
) => {
  const response = await http.get("/notifications", {
    params: { id: userId, limit, offset },
  });
  return response.data;
};
